export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6388.4030f037.jpg";